import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Bootstrap using HttpOnly cookies only. If the cookie is missing or expired
    // /auth/me returns 401 and we fall back to the unauthenticated state.
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const loginSuccess = (data) => {
    // JWT lives in HttpOnly cookies set by /auth/login. No client-side token storage.
    setUser(data.user);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    // Best-effort cleanup of any legacy client-side tokens from prior versions.
    try { localStorage.removeItem("cocoa_token"); } catch { /* storage unavailable */ }
    setUser(false);
  };

  const refresh = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; }
    catch (_) { return null; }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, loginSuccess, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
